import { render, staticRenderFns } from "./RxLoginForm.vue?vue&type=template&id=5a416768&scoped=true"
import script from "./RxLoginForm.vue?vue&type=script&lang=js"
export * from "./RxLoginForm.vue?vue&type=script&lang=js"
import style0 from "./RxLoginForm.vue?vue&type=style&index=0&id=5a416768&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a416768",
  null
  
)

export default component.exports